import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import ChipListSingle from 'shared/components/forms/Chip/ChipListSingle';
import InputLabel from 'shared/components/forms/InputLabel/InputLabel';
import { FlexBoxWrap, FlexBoxAlign, FlexBoxColumn } from 'styles/layout';

const SingleChipSelect = ({
  control,
  name,
  label = null,
  inlineLabel = false,
  disabled = false,
  placeholder = null,
  required = false,
  options,
  onChange,
  error,
}) => {
  const Container = inlineLabel ? FlexBoxAlign : FlexBoxColumn;

  const handleChange = useMemo(
    () =>
      debounce(() => {
        onChange(name);
      }, 500),
    [name, onChange],
  );

  return (
    <Container>
      {label && <InputLabel required={required} error={error} inline={inlineLabel}>{label} {placeholder ?? ''}</InputLabel>}
      <FlexBoxWrap>
        <ChipListSingle
          control={control}
          name={name}
          options={options}
          onChange={handleChange}
          disabled={disabled}
          required={required}
          error={error}
        />
      </FlexBoxWrap>
    </Container>
  );
};

SingleChipSelect.propTypes = {
  control: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  inlineLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.shape({}),
};

export default SingleChipSelect;
